// extracted by mini-css-extract-plugin
module.exports = {"tabList":"styles_tabList__MmEww","tabPanels":"styles_tabPanels__I550H","tabpanel":"styles_tabpanel__rqGyg","tab":"styles_tab__YZaOn","tabselected":"styles_tabselected__Y7GJP","tabnotselected":"styles_tabnotselected__lvK0Y","galeryTab":"styles_galeryTab__GrMsZ"};
module.exports.__checksum = "49bd4c187843"
